"use client"

import { Children, isValidElement, type ReactNode } from "react"

import {
    SidebarProvider,
    Sidebar,
    SidebarHeader,
    SidebarContent,
    SidebarFooter,
} from "@workspace/ui/components/shadcn/sidebar"

import { makeSlot, SLOT_KEY } from "@workspace/ui/lib/makeSlot"

type AppLayoutSlottedProps = {
    children: ReactNode
    sidebarDefaultOpen?: boolean
    LinkComponent?: any
}

export function AppLayoutSlotted({
    children,
    sidebarDefaultOpen = false,
}: AppLayoutSlottedProps) {
    const slots: Record<string, ReactNode> = {}

    Children.forEach(children, (child) => {
        if (!isValidElement(child)) return
        const key = (child.type as any)[SLOT_KEY]
        if (!key) return
        slots[key] = child.props.children
    })

    return (
        <SidebarProvider defaultOpen={sidebarDefaultOpen}>
            <div className="flex min-h-screen w-screen">

                <Sidebar className="hidden lg:flex">
                    <div className="flex flex-col h-full">
                        <SidebarHeader>
                            {slots["sidebar-header"]}
                        </SidebarHeader>

                        <SidebarContent>
                            {slots["sidebar-nav"]}
                        </SidebarContent>

                        <SidebarFooter>
                            {slots["sidebar-footer"]}
                        </SidebarFooter>
                    </div>
                </Sidebar>

                <div className="flex-1 flex flex-col">

                    {slots["topbar"]}

                    <main className="flex-1 overflow-y-auto p-6">
                        {slots["content"]}
                    </main>

                    {slots["footer"]}

                </div>

            </div>
        </SidebarProvider>
    )
}

AppLayoutSlotted.SidebarHeader = makeSlot("sidebar-header")
AppLayoutSlotted.SidebarNav = makeSlot("sidebar-nav")
AppLayoutSlotted.SidebarFooter = makeSlot("sidebar-footer")

AppLayoutSlotted.Topbar = makeSlot("topbar")
AppLayoutSlotted.TopbarLeft = makeSlot("topbar-left")
AppLayoutSlotted.TopbarCenter = makeSlot("topbar-center")
AppLayoutSlotted.TopbarRight = makeSlot("topbar-right")

AppLayoutSlotted.Content = makeSlot("content")
AppLayoutSlotted.Footer = makeSlot("footer")
